import { render } from "./LanguageImport.vue?vue&type=template&id=08875aba&scoped=true"
import script from "./LanguageImport.vue?vue&type=script&lang=js"
export * from "./LanguageImport.vue?vue&type=script&lang=js"

import "./LanguageImport.vue?vue&type=style&index=0&id=08875aba&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08875aba"]])

export default __exports__